import dayjs from "dayjs";
import React from "react";


export const convertStringToMoment = (dateString) => {
    if (!dateString) {
        return null;
    }
    return dayjs(dateString);
}

export const getAction = (message) => {
    return message?.metadata?.debug?.action;
}

export const getParams = (message) => {
    const action = getAction(message);
    if (!action) return {};
    let params = action?.function_to_call?.params || {};
    // remove team_id from params
    delete params.team_id;
    return params;
}

export const getFunctionLabel = (function_name, actionMetadata) => {
    if (actionMetadata && actionMetadata?.functions) {
        const functionConfig = actionMetadata?.functions[function_name];
        if (functionConfig) {
            return functionConfig.label || function_name;
        }
    }
    return function_name;
}

// METRIC UTILS

export const getOptionGroup = (optionGroupName, JSONOptions, metric_type) => {
    let metricObj = {}, metricOps = [];
    metricObj["label"] = <span>{optionGroupName}</span>;
    metricObj["title"] = optionGroupName;

    for (let i = 0; i < JSONOptions.length; i++) {
        const metric = JSONOptions[i];
        if (["gps", "forceplate", "testing", "wellness", "nutrition", "cognition"].includes(metric_type)) {
            metricOps.push({
                label: <span>{metric["name"]}</span>,
                value: `${metric_type}-${metric["metric_id"]}`,
                key: metric["metric_id"]
            });
        }
        else if (metric_type === "player") {
            metricOps.push({
                label: <span>{`${metric["first_name"]} ${metric["last_name"]}`}</span>,
                value: `${metric_type}-${metric["player_id"]}`,
                key: metric["player_id"]
            });
        }
        else if (metric_type === "pos") {
            metricOps.push({
                label: <span>{metric}</span>,
                value: `${metric_type}-${metric}`,
                key: metric
            });
        }
        else if (metric_type === "group") {
            metricOps.push({
                label: <span>{metric["name"]}</span>,
                value: `${metric_type}-${metric["player_group_id"]}`,
                key: metric["player_group_id"]
            });
        }
    }

    if (metric_type === "gps") {
        metricObj["options"] = metricOps;
    } else {
        metricObj["options"] = metricOps.sort((a, b) => {
            const valueA = a?.label?.props?.children || "";
            const valueB = b?.label?.props?.children || "";
            return valueA.localeCompare(valueB);
        });
    }
    return metricObj;
}

export const convertMetricSlugToKey = (metricKey, allMetricTypes, functionConfig) => {
    // filter only available functions
    const availableMetricTypes = Object.fromEntries(
        Object.entries(allMetricTypes).filter(([key, _]) => functionConfig?.metric_types?.includes(key))
    )
    for (const [_, metrics] of Object.entries(availableMetricTypes)) {
        for (let i = 0; i < metrics.length; i++) {
            const metric = metrics[i];
            if (metric?.key === metricKey) {
                return metric.unique_identifier;
            }
        }
    }
    return null;
}

export const convertMetricKeyToSlug = (metricKey, allMetricTypes, functionConfig) => {
    const availableMetricTypes = Object.fromEntries(
        Object.entries(allMetricTypes).filter(([key, _]) => functionConfig?.metric_types.includes(key))
    )
    for (const [_, metrics] of Object.entries(availableMetricTypes)) {
        for (let i = 0; i < metrics.length; i++) {
            const metric = metrics[i];
            if (metric?.unique_identifier === metricKey) {
                return metric.key;
            }
        }
    }
    return null;
}